export class Loading {
    static isLoading: boolean = false
}